var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-container full"},[_c('header-section'),_vm._v(" "),_c('div',{staticClass:"not-found"},[_vm._v("\r\n    Page Not Found\r\n  ")]),_vm._v(" "),_c('footer-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }